import { createApiClient, responseData } from '#lib/api/client.js';

export const getEditionsCart = async (
	fetchFn: typeof globalThis.fetch,
	productIds: string[]
) =>
	responseData(
		await createApiClient(fetchFn).GET('/website-api/pages/cart/editions', {
			params: { query: { productIds: productIds.join(',') } },
		})
	);
